export default {
  popularity: { B0: 77.43382059, B1: -0.05575649, weight: 1 },
  valence: { B0: 0.45803791, B1: 0.00093334, weight: 1 },
  energy: { B0: 0.68606021, B1: -0.00097642, weight: 1 },
  speechiness: { B0: 0.16226628, B1: -0.00157077, weight: 2 },
  acousticness: { B0: 0.1876001, B1: 0.00105243, weight: 0 },
  liveness: { B0: 0.13450753, B1: 0.00084423, weight: 2 },
  danceability: { B0: 0.76218625, B1: -0.00195079, weight: 2 },
  duration_ms: { B0: 186517.51124375, B1: 663.19443412, weight: 2 }
}
